import React, { Component } from 'react';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';

import { COLOR_FONT_1, COLOR_SURFACE_0 } from '../../colors';

/* eslint-disable max-lines-per-function */
/* eslint-disable max-statements */
export class SolidGauge extends Component {
  /**
   *
   */
  componentDidMount() {
    const { chartId, data } = this.props;

    am4core.options.queue = true;
    am4core.options.onlyShowOnViewport = true;

    const chart = am4core.create(chartId, am4charts.RadarChart);
    chart.data = data;

    chart.startAngle = -90;
    chart.endAngle = 180;
    chart.innerRadius = am4core.percent(20);
    chart.numberFormatter.numberFormat = "#.#'%'";
    chart.cursor = new am4charts.RadarCursor();

    const categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis());
    categoryAxis.dataFields.category = 'name_display';
    categoryAxis.renderer.grid.template.location = 0;
    categoryAxis.renderer.grid.template.strokeOpacity = 0;
    categoryAxis.renderer.labels.template.horizontalCenter = 'right';
    categoryAxis.renderer.labels.template.fontWeight = 500;
    categoryAxis.renderer.labels.template.adapter.add('fill', (fill, target) =>
      target.dataItem.index >= 0 ? am4core.color(`#${target.dataItem.dataContext.brand_color}`) : fill
    );
    categoryAxis.renderer.minGridDistance = 10;

    const valueAxis = chart.xAxes.push(new am4charts.ValueAxis());
    valueAxis.min = 0;
    valueAxis.max = 100;
    valueAxis.strictMinMax = true;
    valueAxis.renderer.grid.template.strokeOpacity = 0;
    valueAxis.renderer.labels.template.fill = am4core.color(COLOR_FONT_1);

    const series1 = chart.series.push(new am4charts.RadarColumnSeries());
    series1.dataFields.valueX = 'full';
    series1.dataFields.categoryY = 'name_display';
    series1.clustered = false;
    series1.columns.template.fill = am4core.color(COLOR_SURFACE_0);
    series1.columns.template.strokeWidth = 0;
    series1.columns.template.tooltipText = '{name_display}: [bold]{value}[/]';
    series1.columns.template.radarColumn.cornerRadius = 20;

    const series2 = chart.series.push(new am4charts.RadarColumnSeries());
    series2.dataFields.valueX = 'value';
    series2.dataFields.categoryY = 'name_display';
    series2.clustered = false;
    series2.columns.template.adapter.add('fill', (fill, target) =>
      am4core.color(`#${target.dataItem.dataContext.brand_color}`)
    );
    series2.columns.template.fillOpacity = 1;
    series2.columns.template.strokeWidth = 0;
    series2.columns.template.tooltipText = '{name_display}: [bold]{value}[/]';
    series2.columns.template.radarColumn.cornerRadius = 20;

    this.chart = chart;
  }

  /**
   *
   */
  componentWillUnmount() {
    if (this.chart) {
      this.chart.dispose();
    }
  }

  /**
   *
   */
  render() {
    return <div id={this.props.chartId} style={{ width: '100%', height: '500px' }} />;
  }
}
